module.exports = __webpack_public_path__ + "img/Comic07-2.518d3ccc.png";